import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import AuditLog from '../../../../components/tables/AuditLog';
import { CoreApi } from '../../../../api/api.apiclient';
import { RevisionModel } from '../../../../api/api.types';
import { LoaderBar } from '../../../../components/forms/LoaderBar';

interface CarModelAuditLogLocationProps {
  id: string;
}

const CarModelAuditLog: React.FC<RouteComponentProps<CarModelAuditLogLocationProps>> =
  (props) => {

    const [ revisions, setRevisions ] = useState<RevisionModel[]>([]);
    const [ isLoading, setIsLoading ] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
      const id = props.match.params.id;
      CoreApi.CarModels.getCarModelRevisions(Number(id))
        .then((resp) => setRevisions(resp.data))
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }, [ props.match.params, t ]);

    return (
      <div className="page-content">
        <div className="row justify-content-end pb-2">
          <div className="col-12">
            <h1 className="mb-0">Car model {props.match.params.id} audit log</h1>
          </div>
        </div>
        {isLoading && <LoaderBar/>}
        <AuditLog
          revisions={revisions}
        />
      </div>
    );
  };
export default CarModelAuditLog;